import { schema } from 'normalizr'

export type Discount = {
  id: string
  object_id: number
  value: number
  available: number
  label: string
  type: string
}

export type AppliedDiscount = {
  id: string
  track_id: number
  value: number
  label: string
  type: string
}

export type Currency = {
  id: string
  rate: number
  name: string
}

export const discountSchema = new schema.Entity('discounts')
export const discountListSchema = [discountSchema]
export const currencySchema = new schema.Entity('currencies')
export const currencyListSchema = [currencySchema]
